var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('kendo-grid',{ref:"grid",attrs:{"data-source":_vm.dataSource,"pageable":true,"filterable":true,"sortable":true,"columns":_vm.columns,"resizable":true},on:{"detailinit":_vm.detailInit,"databound":_vm.dataBound}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }